"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.TYPES = exports.MessageType = void 0;
var _objectDestructuringEmpty2 = _interopRequireDefault(require("@babel/runtime/helpers/objectDestructuringEmpty"));
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireWildcard(require("react"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _Avatar = _interopRequireDefault(require("../../Clients/Avatar"));
var _TimeFrom = _interopRequireDefault(require("../../Common/TimeFrom"));
var _AttachmentList = _interopRequireDefault(require("../AttachmentList2"));
var _symbols = require("../../../../constants/symbols");
var _hooks = require("../../../../hooks");
var _getHtmlDocument = _interopRequireDefault(require("../../../../utils/getHtmlDocument"));
var _iconsReact = require("../../../../icons-react");
var _excluded = ["message", "client", "className", "style", "isLast", "isEmail", "rootTicketId", "rootChainId", "onLoadHistoryMessages", "onRevealServiceMessages", "onForwardMessage", "isClosedTicket"];
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
var TYPES = exports.TYPES = {
  AUTO: 'auto',
  TEXT: 'text',
  IMAGE: 'image',
  VOICE: 'voice',
  DOCUMENT: 'document',
  VIDEO: 'video',
  NPS: 'nps',
  SERVICE_MENU: 'service_menu',
  SERVICE_GROUP: 'service_group'
};
var MessageType = exports.MessageType = _propTypes["default"].shape({
  attachments: _propTypes["default"].arrayOf(_propTypes["default"].shape({
    name: _propTypes["default"].string.isRequired,
    size: _propTypes["default"].number.isRequired,
    url: _propTypes["default"].string
  })),
  id: _propTypes["default"].oneOfType([_propTypes["default"].number, _propTypes["default"].string]).isRequired,
  isRead: _propTypes["default"].bool.isRequired,
  isAuto: _propTypes["default"].bool.isRequired,
  isDelivered: _propTypes["default"].bool.isRequired,
  text: _propTypes["default"].string.isRequired,
  time: _propTypes["default"].number.isRequired,
  type: _propTypes["default"].oneOf(Object.values(TYPES)),
  extra: _propTypes["default"].shape({
    bcc: _propTypes["default"].string.isRequired,
    cc: _propTypes["default"].string.isRequired,
    from: _propTypes["default"].string.isRequired
  }),
  isHistory: _propTypes["default"].bool
});
var Message2 = /*#__PURE__*/_react["default"].memo(function (_ref) {
  var message = _ref.message,
    client = _ref.client,
    className = _ref.className,
    style = _ref.style,
    isLast = _ref.isLast,
    isEmail = _ref.isEmail,
    rootTicketId = _ref.rootTicketId,
    rootChainId = _ref.rootChainId,
    onLoadHistoryMessages = _ref.onLoadHistoryMessages,
    onRevealServiceMessages = _ref.onRevealServiceMessages,
    onForwardMessage = _ref.onForwardMessage,
    isClosedTicket = _ref.isClosedTicket,
    props = (0, _objectWithoutProperties2["default"])(_ref, _excluded);
  var avatarUrl = client.avatarUrl,
    fullName = client.fullName,
    number = client.number;
  var id = message.id,
    attachments = message.attachments,
    text = message.text,
    time = message.time,
    type = message.type,
    isAuto = message.isAuto,
    isRead = message.isRead,
    isDelivered = message.isDelivered,
    extra = message.extra,
    isHistory = message.isHistory,
    currentManagerName = message.currentManagerName;
  var processText = (0, _react.useCallback)(function (stringText) {
    var parsedText = stringText.replace(/\s+\n+\s+/gm, '\n');
    var doc = (0, _getHtmlDocument["default"])(parsedText);
    var links = doc.getElementsByTagName('a');
    for (var i = 0; i < links.length; i += 1) {
      links[i].target = '_blank';
    }
    return doc.querySelector('body').innerHTML;
  }, [text]);
  var handleLoadHistoryMessages = (0, _react.useCallback)(function () {
    onLoadHistoryMessages(rootChainId);
  }, [rootTicketId, rootChainId, onLoadHistoryMessages]);
  var handleRevealServiceMessages = (0, _react.useCallback)(function () {
    onRevealServiceMessages(id);
  }, [id, onRevealServiceMessages]);
  var prevText = (0, _hooks.usePrevious)(text);
  var _useState = (0, _react.useState)(processText(text)),
    _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
    processedText = _useState2[0],
    setProcessedText = _useState2[1];
  var isAttachments = attachments && attachments.length;
  (0, _react.useEffect)(function () {
    if (text !== prevText) {
      setProcessedText(processText(text));
    }
  }, [text]);
  var statusBar = (0, _react.useMemo)(function () {
    return /*#__PURE__*/_react["default"].createElement(StyledStatusBar, null, isEmail && /*#__PURE__*/_react["default"].createElement(_TimeFrom["default"], {
      full: true,
      time: time
    }), isDelivered ? /*#__PURE__*/_react["default"].createElement(StyledIsReadIcon, {
      isRead: isRead,
      isAuto: isAuto
    }) : /*#__PURE__*/_react["default"].createElement(StyledIsDeliveredIcon, null), !isClosedTicket && isEmail && /*#__PURE__*/_react["default"].createElement(StyledForwardIcon, {
      onClick: function onClick() {
        onForwardMessage({
          isForwarding: true,
          message: message
        });
      }
    }), !isEmail && /*#__PURE__*/_react["default"].createElement(_TimeFrom["default"], {
      full: true,
      time: time
    }));
  }, []);
  if (type === TYPES.SERVICE_GROUP) {
    return /*#__PURE__*/_react["default"].createElement(StyledMessage, (0, _extends2["default"])({
      isHistory: isHistory,
      className: className,
      style: style
    }, props), /*#__PURE__*/_react["default"].createElement(StyledWrapper, null, /*#__PURE__*/_react["default"].createElement(StyledExtendButton, {
      onClick: handleRevealServiceMessages
    }, "\u041A\u043B\u0438\u0435\u043D\u0442 \u043F\u043E\u043B\u044C\u0437\u0443\u0435\u0442\u0441\u044F \u043C\u0435\u043D\u044E (\u043D\u0430\u0436\u043C\u0438\u0442\u0435 \u0447\u0442\u043E\u0431\u044B \u0440\u0430\u0437\u0432\u0435\u0440\u043D\u0443\u0442\u044C)")));
  }
  return /*#__PURE__*/_react["default"].createElement(StyledMessage, (0, _extends2["default"])({
    isHistory: isHistory,
    className: className,
    style: style
  }, props), isLast && rootChainId && /*#__PURE__*/_react["default"].createElement(StyledHistoryButton, {
    onClick: handleLoadHistoryMessages
  }, /*#__PURE__*/_react["default"].createElement(StyledClockIcon, null), "\u041F\u043E\u043A\u0430\u0437\u0430\u0442\u044C \u043F\u0440\u0435\u0434\u044B\u0434\u0443\u0449\u0443\u044E \u043F\u0435\u0440\u0435\u043F\u0438\u0441\u043A\u0443"), /*#__PURE__*/_react["default"].createElement(StyledWrapper, null, /*#__PURE__*/_react["default"].createElement(StyledAvatar, {
    name: fullName,
    url: avatarUrl
  }), /*#__PURE__*/_react["default"].createElement(StyledContent, null, /*#__PURE__*/_react["default"].createElement(StyledHeadline, null, /*#__PURE__*/_react["default"].createElement(StyledNameWrapper, null, /*#__PURE__*/_react["default"].createElement(StyledName, {
    title: fullName
  }, fullName), extra && extra.from && /*#__PURE__*/_react["default"].createElement(StyledEmail, null, extra.from), number && /*#__PURE__*/_react["default"].createElement(StyledNumber, null, number)), !isEmail && statusBar), extra && (extra.cc || extra.bcc) && /*#__PURE__*/_react["default"].createElement(StyledHeadline, null, /*#__PURE__*/_react["default"].createElement(StyledEmail, null, "\u041A\u043E\u043F\u0438\u0438:", " ".concat(extra.cc || '').concat(extra.bcc && (extra.cc ? ",".concat(extra.bcc) : extra.bcc) || ''))), /*#__PURE__*/_react["default"].createElement(StyledText, {
    dangerouslySetInnerHTML: {
      __html: processedText
    }
  }), isAttachments && /*#__PURE__*/_react["default"].createElement(_AttachmentList["default"], {
    list: attachments
  }), isEmail && statusBar, isEmail && currentManagerName && /*#__PURE__*/_react["default"].createElement(StyledSenderName, null, "\u041E\u0442\u043F\u0440\u0430\u0432\u0438\u0442\u0435\u043B\u044C: ".concat(currentManagerName)))));
});
Message2.displayName = 'Message2';
Message2.propTypes = {
  className: _propTypes["default"].string,
  client: _propTypes["default"].shape({
    avatarUrl: _propTypes["default"].string,
    fullName: _propTypes["default"].string,
    number: _propTypes["default"].number,
    email: _propTypes["default"].string
  }),
  message: MessageType.isRequired,
  style: _propTypes["default"].objectOf(_propTypes["default"].string),
  isLast: _propTypes["default"].bool,
  isEmail: _propTypes["default"].bool,
  rootTicketId: _propTypes["default"].number,
  rootChainId: _propTypes["default"].number,
  onLoadHistoryMessages: _propTypes["default"].func,
  onRevealServiceMessages: _propTypes["default"].func
};
Message2.defaultProps = {
  client: {
    avatarUrl: '',
    fullName: '',
    number: '',
    email: ''
  },
  className: '',
  style: null,
  isLast: false,
  isEmail: true,
  rootTicketId: null,
  rootChainId: null,
  onLoadHistoryMessages: Function.prototype,
  onRevealServiceMessages: Function.prototype
};
var StyledWrapper = _styledComponents["default"].div.withConfig({
  displayName: "Message2__StyledWrapper",
  componentId: "sc-12i1oav-0"
})(["padding-top:3px;padding-bottom:16px;display:flex;flex-direction:row;", ""], function (_ref2) {
  var isEmail = _ref2.isEmail;
  return isEmail && "\n    border-top: 1px #e6e6e6 solid;\n  ";
});
var StyledMessage = _styledComponents["default"].div.withConfig({
  displayName: "Message2__StyledMessage",
  componentId: "sc-12i1oav-1"
})(["box-sizing:border-box;background-color:", ";white-space:revert;border-radius:4px;padding:0 10px;overflow:hidden;&:first-of-type{", "{border-top:none;}}"], function (_ref3) {
  var isHistory = _ref3.isHistory;
  return isHistory ? '#F5F3F2' : 'white';
}, StyledWrapper);
var StyledAvatar = (0, _styledComponents["default"])(_Avatar["default"]).withConfig({
  displayName: "Message2__StyledAvatar",
  componentId: "sc-12i1oav-2"
})(["height:26px;width:26px;min-width:26px;margin-right:8px;"]);
var StyledContent = _styledComponents["default"].div.withConfig({
  displayName: "Message2__StyledContent",
  componentId: "sc-12i1oav-3"
})(["display:flex;flex-direction:column;margin-top:2px;width:100%;> * + *{margin-top:4px;}"]);
var StyledHeadline = _styledComponents["default"].div.withConfig({
  displayName: "Message2__StyledHeadline",
  componentId: "sc-12i1oav-4"
})(["align-items:center;display:flex;width:100%;> * + *{margin-left:5px;}"]);
var StyledNameWrapper = _styledComponents["default"].div.withConfig({
  displayName: "Message2__StyledNameWrapper",
  componentId: "sc-12i1oav-5"
})(["flex:1;"]);
var StyledName = _styledComponents["default"].div.withConfig({
  displayName: "Message2__StyledName",
  componentId: "sc-12i1oav-6"
})(["font-weight:700;overflow:hidden;text-overflow:ellipsis;white-space:nowrap;"]);
var StyledEmail = _styledComponents["default"].span.withConfig({
  displayName: "Message2__StyledEmail",
  componentId: "sc-12i1oav-7"
})(["color:#919499;font-size:12px;"]);
var StyledNumber = _styledComponents["default"].div.withConfig({
  displayName: "Message2__StyledNumber",
  componentId: "sc-12i1oav-8"
})(["font-weight:700;:before{content:'", "';margin-right:5px;}"], _symbols.DOT_OPERATOR);
var StyledText = _styledComponents["default"].div.withConfig({
  displayName: "Message2__StyledText",
  componentId: "sc-12i1oav-9"
})(["overflow-x:auto;overflow-y:hidden;color:#4d4d4d;line-height:18px;width:100%;white-space:pre-line;img{max-width:100%;}.forwarded{border:1px solid #e1e3e1;width:100%;border-radius:10px;padding:5px 10px;}.forwarded-info{font-weight:bold;font-style:italic;}"]);
var StyledExtendButton = _styledComponents["default"].button.withConfig({
  displayName: "Message2__StyledExtendButton",
  componentId: "sc-12i1oav-10"
})(["background:#f5f3f2;padding:3px 13px;border-radius:4px;width:fit-content;color:#1f82fe;cursor:pointer;border:none;outline:none;"]);
var StyledStatusBar = _styledComponents["default"].div.withConfig({
  displayName: "Message2__StyledStatusBar",
  componentId: "sc-12i1oav-11"
})(["align-items:center;display:flex;> * + *{margin-left:10px;}"]);
var StyledIsReadIcon = (0, _styledComponents["default"])(function (_ref4) {
  var props = (0, _extends2["default"])({}, ((0, _objectDestructuringEmpty2["default"])(_ref4), _ref4));
  return /*#__PURE__*/_react["default"].createElement(_iconsReact.CheckDouble, props);
}).withConfig({
  displayName: "Message2__StyledIsReadIcon",
  componentId: "sc-12i1oav-12"
})(["width:20px;height:14px;stroke:", ";", ""], function (_ref5) {
  var isRead = _ref5.isRead;
  return isRead ? '#007aff' : '#979797';
}, function (_ref6) {
  var isAuto = _ref6.isAuto,
    isRead = _ref6.isRead;
  return isAuto && !isRead && "\n    stroke: #007aff;\n    \n    path:nth-child(2) {\n      stroke: #979797;\n    }\n  ";
});
var StyledIsDeliveredIcon = (0, _styledComponents["default"])(function (_ref7) {
  var props = (0, _extends2["default"])({}, ((0, _objectDestructuringEmpty2["default"])(_ref7), _ref7));
  return /*#__PURE__*/_react["default"].createElement(_iconsReact.Check, props);
}).withConfig({
  displayName: "Message2__StyledIsDeliveredIcon",
  componentId: "sc-12i1oav-13"
})(["width:14px;height:8px;stroke:#979797;"]);
var StyledForwardIcon = (0, _styledComponents["default"])(_iconsReact.Forward).withConfig({
  displayName: "Message2__StyledForwardIcon",
  componentId: "sc-12i1oav-14"
})(["width:14px;height:14px;cursor:pointer;"]);
var StyledSenderName = _styledComponents["default"].p.withConfig({
  displayName: "Message2__StyledSenderName",
  componentId: "sc-12i1oav-15"
})(["color:#919499;"]);
var StyledHistoryButton = _styledComponents["default"].button.withConfig({
  displayName: "Message2__StyledHistoryButton",
  componentId: "sc-12i1oav-16"
})(["display:flex;flex-direction:row;justify-content:center;align-items:center;width:100%;background-color:transparent;border:none;outline:none;margin-bottom:5px;color:#007aff;cursor:pointer;padding:3px 0 5px;span{margin-left:6px;color:#007aff;}"]);
var StyledClockIcon = (0, _styledComponents["default"])(_iconsReact.Clock).withConfig({
  displayName: "Message2__StyledClockIcon",
  componentId: "sc-12i1oav-17"
})(["width:16px;height:16px;margin-right:5px;path{stroke:#007aff;}"]);
var _default = exports["default"] = Message2;